/**
 * config
 */
import { InstagramIcon, YoutubeIcon, TwitterIcon, TTIcon, LinkedInPlatformIcon, FacebookIcon } from '@/components/icons';
import {
  orderManuscriptState,
  orderManuscriptStateTitle,
} from '@/biz/orderManuscript';
import { PlatformContentEnum } from '@/pages/CreateCampaign/shared/config';

export {
  orderManuscriptState,
  orderManuscriptStateTitle,
  Product_arrived,
} from '@/biz/orderManuscript';

export enum PlatFormEnum {
  TWITTER = "twitter",
  YOUTUBE = "youtube",
  TIKTOK = "tiktok",
  INSTAGRAM = "instagram",
  LINKEDIN = "linkedin",
  // FACEBOOK = "facebook"
}

export const IconLab: any = {
  [PlatFormEnum.YOUTUBE]: YoutubeIcon,
  [PlatFormEnum.INSTAGRAM]: InstagramIcon,
  [PlatFormEnum.TIKTOK]: TTIcon,
  [PlatFormEnum.TWITTER]: TwitterIcon,
  [PlatFormEnum.LINKEDIN]: LinkedInPlatformIcon
};

export const PlatformContentIconLab: any = {
  [PlatformContentEnum.YOUTUBE_DEDICATED]: YoutubeIcon,
  [PlatformContentEnum.YOUTUBE_INTEGRATED]: YoutubeIcon,
  [PlatformContentEnum.TIKTOK_VIDEO]: TTIcon,
  // [PlatformContentEnum.TIKTOK_INTEGRATED_VIDEO]: TTIcon,
  [PlatformContentEnum.INSTAGRAM_REEL]: InstagramIcon,
  // [PlatformContentEnum.INSTAGRAM_INTEGRATED_REEL]: InstagramIcon,
  [PlatformContentEnum.INSTAGRAM_CAROUSEL_POST]: InstagramIcon,
  // [PlatformContentEnum.INSTAGRAM_INTEGRATED_CAROUSEL_POST]: InstagramIcon,
  [PlatformContentEnum.TWITTER_POST]: TwitterIcon,
  [PlatformContentEnum.LINKEDIN_POST]: LinkedInPlatformIcon,
  [PlatformContentEnum.LINKEDIN_IMAGE_POST]: LinkedInPlatformIcon,
  [PlatformContentEnum.LINKEDIN_VIDEO_POST]: LinkedInPlatformIcon,
  // [PlatformContentEnum.FACEBOOK_POST]: FacebookIcon,
  // [PlatformContentEnum.FACEBOOK_REEL]: FacebookIcon,
};

export const getOrderManuscriptStateTitle = (state: string, t: any, item?: any) => {
  if (
    item?.stage === orderManuscriptState.Collaboration_cancelled &&
    Boolean(item?.collaborationCancellation)
  ) {
    return t(
      "campaignDetail.collaborationCancellation.status.influencerEnded",
      { defaultValue: "Influencer ended the collab" },
    );
  }
  const key = orderManuscriptStateTitle[state] || '';
  if (item?.stage === orderManuscriptState.AccountInfo) {
    return t('orderDetail.manuscriptStates.submitAccount') + " " + ((item?.version && item?.version > 1) ? item?.version : '1') ;
  }
  if (item?.stage === orderManuscriptState.Script) {
    const version = Number(item?.version);
    const number = Number.isFinite(version) && version > 0
      ? version + (item?.contentRoundId ? 0 : 1)
      : 1;
    return t('orderDetail.manuscriptStates.script') + " " + number;
  }
  return key ? t(key) : '';
}

// 广告主操作状态枚举
export enum AdsNextOperateType {
  CreatorApprove = 'CreatorApprove',
  ScriptApprove = 'ScriptApprove',
  Draft_1_Approve = 'Draft_1_Approve',
  Draft_2_Approve = 'Draft_2_Approve',
  Draft_3_Approve = 'Draft_3_Approve',
  Draft_4_Approve = 'Draft_4_Approve',
  Draft_5_Approve = 'Draft_5_Approve',
  OrderComplete = 'OrderComplete',
  ProductShipment = 'ProductShipment',
  InfluencerAccessSetup = 'AccountSetup',
  SelectFromAhaPicks = 'AhaPicks',
}

export const getAdsOperateLab = (t: any) => ({
  [AdsNextOperateType.CreatorApprove]: t('components.adsOperateLab.confirmCollaboration'),
  [AdsNextOperateType.ScriptApprove]: t('components.adsOperateLab.approveDelivery'),
  [AdsNextOperateType.Draft_1_Approve]: t('components.adsOperateLab.approveDelivery'),
  [AdsNextOperateType.Draft_2_Approve]: t('components.adsOperateLab.approveDelivery'),
  [AdsNextOperateType.Draft_3_Approve]: t('components.adsOperateLab.approveDelivery'),
  [AdsNextOperateType.Draft_4_Approve]: t('components.adsOperateLab.approveDelivery'),
  [AdsNextOperateType.Draft_5_Approve]: t('components.adsOperateLab.approveDelivery'),
  [AdsNextOperateType.OrderComplete]: t('components.adsOperateLab.completeCollaboration'),
  [AdsNextOperateType.ProductShipment]: t('components.adsOperateLab.shipProduct', { defaultValue: "Ship product" }),
  [AdsNextOperateType.InfluencerAccessSetup]: t('components.adsOperateLab.influencerAccessSetup', { defaultValue: "Influencer access setup" }),
  [AdsNextOperateType.SelectFromAhaPicks]: t('components.adsOperateLab.selectFromAhaPicks', { defaultValue: "Select from Aha Picks" }),
});

// 触发付款的位置：用来区分后续的弹窗内容显示和样式； 影响范围：PayMethodModal、ModalUpdatePlan
export const payPlaceTypeLists = {
  ORDER_LIST: "orderList",  // 达人列表处
  CAMPAIGN_CREATE_RELEASE: "campaignCreateRelease", // 创建流程release处
  CAMPAIGN_CREATE_RELEASE_ACTIVE: "campaignCreateReleaseActive", // 创建流程release处 且是激活状态
}
